import { HistoryOutlined } from '@ant-design/icons'
import { GraviButton } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'

/** Grid-cell action that opens a HistoryDrawer for the clicked row. */
export function HistoryButton({
  onClick,
  tooltip = 'View History',
}: {
  onClick: () => void
  tooltip?: string
}) {
  return (
    <Tooltip title={tooltip}>
      <GraviButton
        size='middle'
        appearance='text'
        icon={
          <HistoryOutlined
            style={{ color: 'hsl(var(--primary))', fontSize: 18 }}
          />
        }
        onClick={(e) => {
          e.stopPropagation()
          onClick()
        }}
      />
    </Tooltip>
  )
}
